import type React from "react";

import { css, cx } from "simplydo/react/styled";
import { Card } from "simplydo/react/ui/card";

const shadowedCardClass = css`
  -webkit-box-shadow: -1px 5px 33px -7px rgba(0, 0, 0, 0.41) !important;
  -moz-box-shadow: -1px 5px 33px -7px rgba(0, 0, 0, 0.41) !important;
  box-shadow: -1px 5px 33px -7px rgba(0, 0, 0, 0.41) !important;

  &:hover {
    -webkit-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
  }

  &&& {
    color: #000;
  }
`;

type ShadowedCardProps = {
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  content?: React.ReactNode;
  onCardClicked?: () => void;
};

const ShadowedCard = ({
  style,
  className,
  children,
  content,
  onCardClicked,
}: ShadowedCardProps) => {
  return (
    <Card
      onClick={onCardClicked}
      style={style}
      className={cx(shadowedCardClass, className)}
    >
      {children || content}
    </Card>
  );
};

export default ShadowedCard;
